import React from 'react';
import classNames from 'classnames';
import ModalCloseBtn from '../ModalCloseBtn';

import { ModalHeaderProps } from '../types';
import styles from './index.module.scss';

const ModalHeader: React.FC<ModalHeaderProps> = ({
    children,
    hasCloseBtn = true,
    closeBtn,
    className,
    titleClassName,
    centered = false,
    floating = false
}) => (
    <div className={classNames('flex flex-items-baseline p-t-24', styles.header, { [styles.floating]: floating }, className)}>
        {children && (
            <div className={classNames(styles.titleContainer, { 't-a-center': centered })}>
                <h4 className={classNames('m-0', styles.title, titleClassName)}>{children}</h4>
            </div>
        )}
        {hasCloseBtn && (
            closeBtn || <ModalCloseBtn/>
        )}
    </div>
);

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;
